import type { InstallAppResponse } from '@wix/app-installer/types';
import { getPostInstallationUrlWithQuery } from './getPostInstallationUrl';

export const usePostInstallationUrl = () => {
  const isValidUrl = (url: string): boolean => {
    try {
      new URL(url);
      return true;
    } catch (e) {
      console.error('postInstallationUrl is invalid', e);
      return false;
    }
  };

  const postInstallationUrlQuery =
    new URLSearchParams(window.location.search).get('postInstallationUrl') ||
    undefined;

  const hasPostInstallationUrl =
    !!postInstallationUrlQuery && isValidUrl(postInstallationUrlQuery);

  const redirectToPostInstallationUrlIfRequired = (
    response: InstallAppResponse,
  ) => {
    if (response.status === 'SUCCESS' && hasPostInstallationUrl) {
      const {
        tenantId: responseTenantId,
        appId,
        instanceId,
      } = response.installedApps[0];
      const postInstallationUrl = getPostInstallationUrlWithQuery({
        postInstallationUrl: postInstallationUrlQuery,
        appId,
        tenantId: responseTenantId,
        instanceId,
      });
      window.location.assign(postInstallationUrl!);
    }
  };
  return {
    hasPostInstallationUrl,
    redirectToPostInstallationUrlIfRequired,
  };
};
